<template>
    <Breadcrumbs main="Bonus Ui" title="Creative Card" />
    <div class="container-fluid">
        <div class="row">
            <borderCard />
            <primaryState />
            <warningState />
            <secondaryState />
            <absoluteCard />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const borderCard = defineAsyncComponent(() => import("@/components/theme/advance/creative/borderCard.vue"))
const primaryState = defineAsyncComponent(() => import("@/components/theme/advance/creative/primaryState.vue"))
const warningState = defineAsyncComponent(() => import("@/components/theme/advance/creative/warningState.vue"))
const secondaryState = defineAsyncComponent(() => import("@/components/theme/advance/creative/secondaryState.vue"))
const absoluteCard = defineAsyncComponent(() => import("@/components/theme/advance/creative/absoluteCard.vue"))
</script>